import * as React from "react";
import { Link } from "gatsby";
import HeaderMenu from "../components/HeaderMenu/HeaderMenu";
import { withLayout, LayoutProps, menuItems } from "../components/Layout";
import {
  Button,
  Segment,
  Container,
  Grid,
  Header,
  Icon,
} from "semantic-ui-react";

import homepageGif from '../assets/shark.gif'

const IndexPage = (props: LayoutProps) =>
  <div>
    {/* Master head */}
    <Segment vertical inverted textAlign="center" className="masthead">
      <HeaderMenu
        Link={Link} pathname={props.location.pathname} items={menuItems} inverted
      />
      <Container text>
        <Header inverted as="h1">BubblesDeep</Header>
        <Header inverted as="h2">Convert Underwater Photos and Videos</Header>
        <Button primary size="huge">Convert</Button>
      </Container>
    </Segment>

    {/* About this starter */}
    <Segment vertical className="stripe">
      <img src={homepageGif} alt={"side-by-side of underwater video"}/>
    </Segment>
  </div>


export default withLayout(IndexPage);
